import { render, staticRenderFns } from "./Deposit.vue?vue&type=template&id=28972dcb&scoped=true&"
import script from "./Deposit.vue?vue&type=script&lang=js&"
export * from "./Deposit.vue?vue&type=script&lang=js&"
import style0 from "./Deposit.vue?vue&type=style&index=0&id=28972dcb&prod&lang=scss&"
import style1 from "./Deposit.vue?vue&type=style&index=1&id=28972dcb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28972dcb",
  null
  
)

export default component.exports